import * as Yup from 'yup';
import { htmlStringHasText, createMediaSchema } from 'utils/sharedSchema.utils.js';

const productAboutSchema = Yup.object().shape({
  description: Yup.string().label('Product description').default('').test(htmlStringHasText),
  headline: Yup.string().label('Headline').required().default(''),
  image: createMediaSchema('Your product image is missing'),
});

export default productAboutSchema;
